const tableList = {
    data() {
      return {
        pages:{
          current:1,
          pageSize:10,
          total:0
        },
        isloading:false,
        isFinish:false,
        list:[]
      };  
    },
    components:{
      
    },
    mounted: function () {
       
    },
    methods: {
      clearList(){
        //清空
        let that=this;
        that.pages = {
            current:1,
            pageSize:10,
            total:0
        };
        that.list = [];
      },
      loaderMore(id='scrollContent',loaderFn){
        //监听页面上 id 为 id的元素 如果滚动到底部则执行加载方法 loaderFn
        //todo :可能方法要完善
        let that=this;
        const element = document.getElementById(id);
        element.addEventListener("scroll", () => {
        // 判断是否滚动到底部
   
        const isAtBottom = element.scrollTop + element.clientHeight >= element.scrollHeight-20;
        
        if (isAtBottom&&!that.isloading&&!that.isFinish) {
        // 执行加载方法 loaderFn
            loaderFn();
        }
        });
      } 

  
    },
   
  };

  export default tableList;
